import { ConcreteEncodable } from "./ConcreteEncodable";

import { SuspensionDetailsImplEncoder } from "../../encoder/SuspensionDetailsImplEncoder";

import * as CubiqTS from "../../index";
import { SuspensionDetails } from "../SuspensionDetails";

export class SuspensionDetailsImpl extends ConcreteEncodable implements SuspensionDetails {
  public static enType: string = "com.bcdfx.model.event.lifecycle.fx.SuspensionDetailsImpl";

  /*FID=100*/
  public messageId: string;
  /*FID=931*/
  public suspensionFromDts: CubiqTS.moment.Moment | null = null;
  /*FID=932*/
  public suspensionToDts: CubiqTS.moment.Moment | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = SuspensionDetailsImplEncoder.Instance;
    this.setEncodableType(SuspensionDetailsImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "SuspensionDetailsImpl[" +
      "messageId=" +
      this.messageId +
      "suspensionFromDts=" +
      this.suspensionFromDts +
      "suspensionToDts=" +
      this.suspensionToDts +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
